export default __webpack_public_path__ + "static/media/select.8459500b.png";